export default "__VITE_ASSET__OwuVgR$X__"